import { mixtilesAxios } from '../utils/ApiUtils'

export const PATH = 'collage-layouts'

export const getCollageLayouts = async (
  photosCount,
  tileSize,
  portfolioVariant
) => {
  const response = await mixtilesAxios.get(
    `${PATH}/?photosCount=${photosCount}&tileSize=${tileSize}&portfolioVariant=${portfolioVariant}`
  )
  return response.data.list
}

export const getCollageLayoutsPerStyle = async (
  layoutStyles,
  photosCount,
  tileSize,
  portfolioVariant
) => {
  const formattedStyles = layoutStyles.join(',')
  const response = await mixtilesAxios.get(
    `${PATH}/per-style?layoutStyles=${formattedStyles}&photosCount=${photosCount}&tileSize=${tileSize}&portfolioVariant=${portfolioVariant}`
  )
  return response.data.list
}
